import React from 'react';
import NavBar from '../components/Navbar';
import DesignBanner from '../components/Banner/DesignBanner';
import FooterData from '../components/Footer/FooterData';
import FooterSecurity from '../components/Footer/FooterSecurity';
import AppWork from "../components/Service/AppWork";
import Services from "../components/Services";
import ServiceData from "../components/Service/ServiceData";
import Contacts from "../components/Contacts";

export const Home = () => (
    <div className="body_wrapper">
      {/*<CustomNavbar cClass="custom_container p0" hbtnClass="new_btn"/>*/}
      <NavBar mClass="menu_four" nClass="" hbtnClass="new_btn"/>

      {/*  Home   */}
      <DesignBanner/>

      {/*  Services   */}
      <Services/>


      {/*<HostingService/>*/}
      {/*  <HostingFeatures/>*/}
      {/*  <HostingFeaturesTwo/>*/}



      {/*  About   */}

      {/*<Subscribe FooterData={FooterData}/>*/}

      <AppWork ServiceData={ServiceData}/>

      {/*  Contact   */}
      <Contacts/>

      {/*  Footer  */}
      <FooterSecurity FooterData={FooterData}/>
    </div>
);
